import { render, staticRenderFns } from "./MurderousContagionArticle.vue?vue&type=template&id=aa64df46&"
import script from "./MurderousContagionArticle.vue?vue&type=script&lang=js&"
export * from "./MurderousContagionArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports